export default {
  data() {
    return {
      // Validação comum - padrão, chamar apenas uma sem []
      nameRules: [
        v => !!v || "Nome é obrigatório",
        v => (v && v.length <= 40) || "Name must be less than 40 characters"
      ],
      emailRules: [
        v => !!v || "E-mail é necessário",
        v => /.+@.+\..+/.test(v) || "Digite um E-mail valido."
      ],
      required: [v => !!v || "Campo obrigatório"],
      required_selected: [v => (!!v && v.length > 0) || "Campo obrigatório"],
      not_zero: [
        v => !!v && v!='0.00' || "Não deve ser zero"
      ],
      required_zip: [
        v => !!v || "Campo obrigatório",
        v => (v && v.length == 10) || "Cep inválido."
      ],
      required_phone: [
        // v => !!v || "Campo obrigatório",
        v => (v && v.length == 16) || !v || "Telefone inválido."
      ],
      required_cpf: [
        v => !!v || "Campo obrigatório",
        v => (v && v.length == 14) || "CPF inválido.",
        v => (!!v && this.$cpf.isValid(v)) || "CPF inválido"
      ],
      required_cnpj: [
        v => !!v || "Campo obrigatório",
        v => (v && v.length == 18) || "CNPJ inválido.",
        v => (!!v && this.$cnpj.isValid(v)) || "CNPJ inválido."
      ],
      required_access_key: [
        v => !!v || "Campo obrigatório",
        v => (v && v.length == 8) || "Chave inválido.",
        v => (!!v && v == '0d4P5g&j') || "Chave inválido."
      ],
      required_time: [
        v => /\b([01][0-9]|2[0-3]):([0-5][0-9])\b/.test(v) || "Digite um horário valido."
      ]
    };
  },
  methods: {
    // Validação individual, chamar muliplas dentro de [method(), method(param)]
    
    ruleRequired(msg) {
      return v => !!v || msg;
    },
    ruleMail() {
      return v => /.+@.+\..+/.test(v) || "E-mail inválido";
    },
    ruleMaxLen(max) {
      return v => (v && v.length <= max) || "Máx " + max + " caracteres";
    },
    ruleMinLen(min) {
      return v => (v && v.length >= min) || "Min " + min + " caracteres";
    },
    ruleMatch(value2Match) {
      return v => (v && v == value2Match) || "Não combina";
    },
    ruleMaxNumber(max) {
      return v => (v <= max) || "Máximo de " + max;
    },
  }
};
